import React, { useEffect, useState } from 'react';
import '../../Styles/Partials/SitewideBanner.css';
import { handleStripePortalRedirect } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { CloseButton } from '../Layout/Buttons/CloseButton';
import { useWindow } from '../../contexts/WindowContext';

const SitewideBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const auth = useAuth();
  const { windowWidth } = useWindow();

  useEffect(() => {
    if (auth.billingIssue) {
      setIsVisible(true);
    }
  }, [auth.billingIssue]);

  if (!isVisible) return null;

  return (
    <div className="sitewide-banner">
      <div className="banner-content">
        Your latest payment has failed. 
        {windowWidth > 768 && (
          <button onClick={() => handleStripePortalRedirect(window.location.href)} className="link-like-button">
            Update payment information.
          </button>
        )}
      </div>
      <CloseButton onClick={() => setIsVisible(false)} />
    </div>
  );
};

export default SitewideBanner;